import { render, staticRenderFns } from "./Permissao.vue?vue&type=template&id=eb6f3c02&scoped=true&"
import script from "./Permissao.vue?vue&type=script&lang=js&"
export * from "./Permissao.vue?vue&type=script&lang=js&"
import style0 from "./Permissao.vue?vue&type=style&index=0&id=eb6f3c02&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "eb6f3c02",
  null
  
)

export default component.exports